import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../components/CheckboxResearch';

const SectionCheckboxes = ({ sostenibile, updateField }) => (
	<div className="section-checkboxes has-border-bottom p-b-24 p-t-16">
		<Checkbox
			type="sostenibile"
			text=" Servizi Sostenibili"
			updateField={updateField}
			checked={sostenibile}
		/>
	</div>
);

SectionCheckboxes.propTypes = {
	sostenibile: PropTypes.instanceOf(Boolean).isRequired,
	updateField: PropTypes.instanceOf(Function).isRequired,
};

export default SectionCheckboxes;
